import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16">
      <Seo
        title="Il Metodo Rarium — Come Autentichiamo Ogni Lotto"
        description="La disciplina editoriale di una casa d'asta storica, la velocità del digitale. Scopri come i nostri curatori indipendenti autenticano e presentano ogni oggetto."
        path="/about"
      />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="overline text-stone-500">{t("Manifesto")}</div>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-4 leading-none">{t("Il metodo ")}<em className="text-[#8C3A3A] not-italic">Rarium</em>.</h1>
        </div>
        <div className="lg:col-span-8 space-y-8 text-lg leading-relaxed text-stone-700">
          <p className="font-serif text-2xl leading-snug">
            {t("Crediamo che gli oggetti rari non abbiano bisogno di essere venduti. Hanno bisogno di essere ")}<em>{t("capiti")}</em>{t(", raccontati, e messi davanti alle persone giuste.")}
          </p>
          <p>{t("Rarium è nata a Milano nel 2026 da un gruppo di curatori, orologiai, sommelier e restauratori che condividevano una stessa frustrazione: le case d'asta tradizionali sono lente, le piattaforme online sono superficiali.")}</p>
          <p>{t("Abbiamo costruito qualcosa di diverso — una piattaforma che unisce la ")}<strong>{t("disciplina editoriale")}</strong>{t(" di una casa d'asta storica alla ")}<strong>{t("velocità")}</strong>{t(" del digitale, con la ")}<strong>{t("trasparenza")}</strong>{t(" radicale di internet.")}</p>
          <div className="rule pt-8 grid grid-cols-3 gap-6">
            <Kpi n="7" l={t("Categorie curate")} />
            <Kpi n="180+" l={t("Esperti indipendenti")} />
            <Kpi n="4.8/5" l={t("Rating collezionisti")} />
          </div>
          <Link to="/sell" data-testid="about-sell-cta" className="inline-block mt-10 text-xs uppercase tracking-widest font-semibold bg-[#8C3A3A] hover:bg-[#7F3434] text-stone-50 px-8 py-4 transition-colors">{t("Metti in asta il tuo pezzo →")}</Link>
        </div>
      </div>
    </div>
  );
}
const Kpi = ({ n, l }) => (
  <div>
    <div className="font-serif text-3xl">{n}</div>
    <div className="overline text-stone-500 mt-1">{l}</div>
  </div>
);
